/* pippei.no – kurvvakt: holder linjeegenskapen «Forventet klar» lik kurvteksten (Kalles)
   Leser [data-pippei-fk] som snippets/cart-item.liquid og cart-item-page.liquid rendrer per linje.
   Kjører på cart:updated (temaet sender den etter at kurv-DOM-en er byttet) og én gang ved lasting
   når temaets kurvmodul er klar. */
(function () {
  'use strict';
  var PROP = 'Forventet klar';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CHANGE = (window.T4Sroutes && T4Sroutes.cart_change_url ? T4Sroutes.cart_change_url : root + 'cart/change') + '.js';
  var ATTEMPT_LIMIT = 2, ATTEMPT_WINDOW = 60000;   // per variant og måltekst: maks 2 kall per minutt (stopper vipping)
  var ROUND_LIMIT = 4, ROUND_WINDOW = 10000;        // globalt: maks 4 runder per 10 s; overskudd utsettes, forkastes ikke
  var BLOCK_MAX = 4000;                             // sikkerhet: aldri lås kurven lenger enn 4 s
  var busy = false, attempts = {}, rounds = [], blocked = [], disabled = [], timer = null, retry = null;

  function post(body) {
    return fetch(CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('HTTP ' + r.status));
        return j;
      });
    });
  }

  /* Liquid skriver `item.properties | json` som en liste av [navn, verdi]-par (ikke som objekt);
     begge former godtas. null når attributtet mangler eller ikke lar seg tolke: linjen hoppes over,
     for change.js erstatter hele egenskapssettet, og et tomt sett ville slettet de andre egenskapene. */
  function parseProps(raw) {
    if (raw === null || raw === undefined || raw === '') return null;
    try {
      var p = JSON.parse(raw);
      if (Array.isArray(p)) {
        var o = {};
        for (var i = 0; i < p.length; i++) {
          if (!Array.isArray(p[i]) || p[i].length !== 2 || typeof p[i][0] !== 'string') return null;
          o[p[i][0]] = p[i][1] === null || p[i][1] === undefined ? '' : String(p[i][1]);
        }
        return o;
      }
      return (p && typeof p === 'object') ? p : null;
    } catch (e) { return null; }
  }

  /* Eldre kurver kan ha «_Forventet klar» fra før navnebyttet; bare PROP skal stå igjen. */
  function isLegacyProp(name) {
    return name !== PROP && /^_?forventet klar:?$/i.test(String(name).trim());
  }

  /* Ny verdi for egenskapen, eller null når linjen skal stå urørt:
     - linjen må ikke vente lenger, men har egenskap  -> '' (checkout viser ikke tom verdi)
     - linjen må vente, kurvteksten har dato og avviker -> kurvteksten
     - linjen må vente uten kjent dato                 -> urørt (behold det produktsiden satte) */
  function target(el) {
    var vent = el.getAttribute('data-vent') === 'true';
    var tekst = (el.getAttribute('data-tekst') || '').trim();
    var egenskap = (el.getAttribute('data-egenskap') || '').trim();
    if (!vent) return egenskap !== '' ? '' : null;
    if (tekst !== '' && tekst !== egenskap) return tekst;
    return null;
  }

  function cartModuleReady() {
    return !!(window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.getToFetch === 'function');
  }

  /* Blokker mus og tastatur i kurven mens kallene pågår (temaets egen klasse fjernes av temaet selv). */
  function block(el) {
    var w = el.closest('[data-cart-wrapper]');
    if (!w || blocked.indexOf(w) !== -1) return;
    blocked.push(w);
    w.style.pointerEvents = 'none';
    Array.prototype.forEach.call(w.querySelectorAll('input, button, select, textarea'), function (f) {
      if (!f.disabled) { f.disabled = true; disabled.push(f); }
    });
  }
  function release() {
    blocked.forEach(function (w) { w.style.pointerEvents = ''; });
    disabled.forEach(function (f) { f.disabled = false; });
    blocked = []; disabled = [];
    if (timer) { clearTimeout(timer); timer = null; }
  }
  function armTimer() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(release, BLOCK_MAX);
  }

  function attemptsWithin(stamp, now) {
    var list = (attempts[stamp] || []).filter(function (t) { return now - t < ATTEMPT_WINDOW; });
    attempts[stamp] = list;
    return list.length;
  }

  function reconcile() {
    if (busy) return;
    if (retry) { clearTimeout(retry); retry = null; }
    var now = Date.now();
    var ops = [], seenKey = {}, seenVariant = {};

    Array.prototype.forEach.call(document.querySelectorAll('[data-pippei-fk]'), function (el) {
      var key = el.getAttribute('data-key');
      var variant = el.getAttribute('data-variant') || key;
      var qty = parseInt(el.getAttribute('data-qty'), 10);
      if (!key || !(qty > 0) || seenKey[key]) return;   // samme linje kan stå både i minihandlekurv og på kurvsiden
      seenKey[key] = true;
      var value = target(el);
      if (value === null) return;
      /* Én operasjon per variant per runde: to linjer av samme variant kan bli slått sammen av Shopify
         når egenskapene blir like, og da er nøkkel og antall for den andre linjen foreldet. Neste
         runde (etter ny rendring) tar resten med ferske nøkler. */
      if (seenVariant[variant]) return;
      var stamp = variant + '|' + value;
      if (attemptsWithin(stamp, now) >= ATTEMPT_LIMIT) return;
      var props = parseProps(el.getAttribute('data-props'));
      if (props === null) { console.error('pippei-forventet-klar: uleselige egenskaper, linje hoppes over', key); return; }
      Object.keys(props).forEach(function (name) { if (isLegacyProp(name)) delete props[name]; });
      props[PROP] = value;
      seenVariant[variant] = true;
      ops.push({ el: el, stamp: stamp, body: { id: key, quantity: qty, properties: props } });
    });
    if (!ops.length) { release(); return; }

    rounds = rounds.filter(function (t) { return now - t < ROUND_WINDOW; });
    if (rounds.length >= ROUND_LIMIT) {
      // Ikke forkast avviket: prøv igjen når vinduet åpner seg (ingen ny cart:updated kommer av seg selv).
      release();
      retry = setTimeout(reconcile, ROUND_WINDOW - (now - rounds[0]) + 50);
      return;
    }
    rounds.push(now);

    busy = true;
    ops.forEach(function (op) { block(op.el); });
    armTimer();
    var done = 0;
    ops.reduce(function (chain, op) {
      return chain.then(function () {
        (attempts[op.stamp] = attempts[op.stamp] || []).push(Date.now());
        return post(op.body).then(function () { done++; });
      });
    }, Promise.resolve())
      .catch(function (e) { console.error('pippei-forventet-klar', e); })
      .then(function () {
        busy = false;
        if (done > 0 && cartModuleReady()) {
          // Temaet henter seksjonene, rendrer og sender cart:updated; neste runde finner ingen avvik og frigir.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          release();
        }
      });
  }

  /* Ved lasting: vent til temaets kurvmodul (interactable.min.js lastes sent) er klar, ellers får
     cart:refresh ingen lytter. På sider med minihandlekurv kommer dessuten temaets egen cart:updated. */
  function start(tries) {
    if (cartModuleReady()) { reconcile(); return; }
    if (tries > 0) setTimeout(function () { start(tries - 1); }, 250);
  }

  document.addEventListener('cart:updated', reconcile);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(40); });
  else start(40);
})();
